<script>
// import api from '@utils/api'
// import * as compare from '@utils/comparers'
import axios from 'axios'
import isMobileDevice from '@utils/helpers/is-mobile'

import SerialSearch from '@components/serial-search'
import { createBarcodeScanner } from '@utils/barcode/barcode-scanner'

export default {
  name: 'CreateDeviceDialog',
  components: {
    SerialSearch,
    createBarcodeScanner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    clonedItem: {
      type: Object,
      required: false,
      default: null,
    },
    workshopId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    warehouseId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      formValidState: false,
      isLoading: false,
      isMobile: isMobileDevice(),
      scannerIsVisible: false,
      barcodeScanner: createBarcodeScanner(document),
      item: {
        fromWarehouse: null,
        plugSerial: null,
        drum: null,
        oil: null,
        doShipment: false,
      },
      rules: {
        fromWarehouse: [x => !!x || this.$t('validation__is_required')],
        toOrganisation: [x => !!x || this.$t('validation__is_required')],
        oil: [x => !!x || this.$t('validation__is_required')],
        drum: [x => !!x || this.$t('validation__is_required')],
        serial: [x => !!x || this.$t('validation__is_required')],
        serial_text: [
          x =>
            (!!x && /^[A-Z0-9]+$/.test(x)) ||
            this.$t('validation__is_capital_latin_and_digits'),
        ],
      },
    }
  },
  computed: {
    oils() {
      return this.$store.getters['data/getOil']
    },
    drums() {
      return this.$store.getters['data/getDrum']
    },
    dialogShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    warehouses() {
      let warehouses = this.$store.getters['data/getWarehouses']
      if (this.workshopId) {
        let workshop = this.$store.getters['data/getItemFromDictionary'](
          'organization',
          this.workshopId
        )
        return warehouses.filter(w => w.parent === workshop.parent)
      } else return warehouses
    },
    workshops() {
      let workshops = this.$store.getters['data/getWorkshopsFromOrganizations']
      if (this.warehouseId) {
        let warehouse = this.$store.getters['data/getItemFromDictionary'](
          'organization',
          this.warehouseId
        )
        return workshops.filter(w => w.parent === warehouse.parent)
      } else {
        return workshops
      }
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value ? Number(value) : value
      )
    },
    openBarcodeScanner(field, applyValueFn) {
      this.scannerIsVisible = true
      this.barcodeScanner.openScannerForField(
        value => applyValueFn(value),
        () => this.closeScanner()
      )
    },
    closeScanner() {
      this.barcodeScanner.closeScanner()
      this.scannerIsVisible = false
    },
    setPlugSerial(value) {
      this.item.plugSerial = value
    },
    submit() {
      let clonedItems = {}
      const isFormValid = this.$refs.newItemForm.validate()
      if (!isFormValid) return
      const fromOrganisation = this.warehouseId
        ? this.warehouseId
        : this.item.fromWarehouse
      const toOrganisation = this.workshopId
        ? this.workshopId
        : this.item.toOrganisation
          ? this.item.toOrganisation
          : this.item.fromWarehouse

      if (this.clonedItem) {
        clonedItems = {
          oilId: this.clonedItem.oil,
          drumId: this.clonedItem.drum,
        }
      }

      this.isLoading = true
      let doShipment = this.workshopId != null || this.item.doShipment
      axios
        .post(`/api/1/devices`, {
          serial: this.item.plugSerial,
          oilId: this.item.oil,
          drumId: this.item.drum,
          ...clonedItems,
          fromOrganisation,
          toOrganisation,
          doShipment: doShipment,
        })
        .then(response => {
          this.isLoading = false
          if (doShipment) {
            this.$store.commit('notifications/ADD', {
              type: 'success',
              message:
                this.$t('message__device_successfully_shipped_to_workshop') +
                this.getValue('organization', toOrganisation),
            })
          }
          this.$refs.newItemForm.reset()
          this.$emit('on-created')
        })
        .catch(error => {
          this.isLoading = false
          console.error(error)
        })
    },
    closeDialog() {
      this.$refs.newItemForm.reset()
      this.$emit('close-clicked')
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="dialogShow"
    :content-class="$style.relativePosition"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div
          v-if="clonedItem"
          class="headline">{{ $t('titles__clone_device') }}</div>
        <div
          v-else
          class="headline">{{ $t('titles__new_device') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newItemForm"
                v-model="formValidState">
                <v-layout
                  row
                  align-center>
                  <v-flex>
                    <v-text-field
                      v-model="item.plugSerial"
                      :rules="rules.serial_text"
                      :label="$t('label__device_serial')"
                      autocomplete="off"
                      required
                    />
                  </v-flex>
                  <v-flex
                    shrink>
                    <img
                      class="barcodeScanIcon"
                      src="@assets/images/barcode_scan_icon.png"
                      @click="openBarcodeScanner('serial', setPlugSerial)"
                    >
                  </v-flex>
                </v-layout>
                <v-layout column>
                  <v-flex>
                    <v-select
                      v-if="!warehouseId"
                      :items="warehouses"
                      :label="workshopId ? $t('label__fromWarehouse') : $t('label__toWarehouse')"
                      :rules="rules.fromWarehouse"
                      v-model="item.fromWarehouse"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-if="clonedItem"
                      :value="getValue('goods', clonedItem.drum)"
                      :label="$t('label__drum')"
                      autocomplete="off"
                      disabled
                    />
                    <v-select
                      v-else
                      :items="drums"
                      :label="$t('label__drum')"
                      :rules="rules.drum"
                      v-model="item.drum"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-if="clonedItem"
                      :value="getValue('goods', clonedItem.oil)"
                      :label="$t('label__oil')"
                      autocomplete="off"
                      disabled
                    />
                    <v-select
                      v-else
                      :items="oils"
                      :label="$t('label__oil')"
                      :rules="rules.oil"
                      v-model="item.oil"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                  <v-flex>
                    <v-checkbox
                      v-if="warehouseId"
                      v-model="item.doShipment"
                      :label="$t(`label__shipment`)"
                      primary
                      hide-details
                      @click.stop
                    />
                    <v-select
                      v-if="item.doShipment"
                      :items="workshops"
                      :label="$t('label__toWorkshop')"
                      :rules="rules.toOrganisation"
                      v-model="item.toOrganisation"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="isLoading"
          color="secondary"
          @click="closeDialog">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="!formValidState || isLoading"
          :loading="isLoading"
          color="success"
          @click="submit">{{ $t('buttons__create') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      v-show="scannerIsVisible"
      id="scanner-container"
      class="scannerContainer">
      <v-btn
        class="scannerCancelBtn"
        color="secondary"
        @click="closeScanner()"
      >
        {{ $t('buttons__cancel') }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" module>
@import '@design';

.relativePosition {
  position: relative;
}
</style>
